import React from 'react';
import i18 from '../../../i18';
import Modal from 'react-modal';


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

class RuleViewModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            config: props.config,
            rule: props.rule,
        }
    }

    render = () => {
        return <Modal
            isOpen={true}
            onRequestClose={() => this.props.closeModal()}
            style={customStyles}
            contentLabel={i18.COMMON._showRuleText}>
            <div className='modal-body'>
                <table className='table table-striped table-aibook-no-border'>
                    <tbody>
                    <tr>
                        <td>Azonsító</td>
                        <td>#{this.state.rule.id}</td>
                    </tr>
                    <tr>
                        <td>{i18.CUSTOMER._typeOfTraffic}</td>
                        <td>{this.state.rule.item_name}</td>
                    </tr>
                    <tr>
                        <td>{i18.CUSTOMER._invoiceNumber}</td>
                        <td>{this.state.rule.invoice_number}</td>
                    </tr>
                    {this.state.config.positionNumberVisible
                        ? <React.Fragment>
                            <tr>
                                <td>{i18.CUSTOMER._positionNumber}</td>
                                <td>{this.state.rule.position_number}</td>
                            </tr>
                            <tr>
                                <td>{i18.CUSTOMER._positionNumberCountry}</td>
                                <td>{this.state.rule.position_number_country}</td>
                            </tr>
                        </React.Fragment>
                        : null
                    }
                    <tr>
                        <td>{i18.CUSTOMER._mainBookNumber}</td>
                        <td>{this.state.rule.main_bookkeeping_number}</td>
                    </tr>
                    <tr>
                        <td>{i18.CUSTOMER._VAT}</td>
                        <td>{this.state.rule.vat}%</td>
                    </tr>
                    <tr>
                        <td>{i18.CUSTOMER._collectorCode}</td>
                        <td>{this.state.rule.vatCode ? this.state.rule.vatCode.code : null}</td>
                    </tr>
                    <tr>
                        <td>{i18.CUSTOMER._taxNumber}</td>
                        <td>{this.state.rule.companyType}</td>
                    </tr>
                    <tr>
                        <td>{i18.CUSTOMER._vatDegreeNumber}</td>
                        <td>{this.state.rule.vat_degree}</td>
                    </tr>
                    <tr>
                        <td>{i18.COMMON._typeOfRule}</td>
                        <td>{this.state.rule.typeLabel}</td>
                    </tr>
                    <tr>
                        <td>{i18.COMMON._position}</td>
                        <td>{this.state.rule.position}</td>
                    </tr>
                    <tr>
                        <td>{i18.COMMON._updatedAt}</td>
                        <td>{this.state.rule.updated_at}</td>
                    </tr>
                    </tbody>
                </table>
                <div className='text-center'>
                    <a onClick={() => this.props.closeModal()} className='btn btn-danger btn-sm'>{i18.COMMON._close}</a>
                </div>
            </div>
        </Modal>
    }
}

export default RuleViewModal


// WEBPACK FOOTER //
// ./src/components/customer/Rules/RuleViewModal.js